import { Box, Button, Typography } from '@mui/material';

import { AuthSectionSteps } from '../../types/AuthSectionSteps';

interface StepNoLinkedCompaniesProps {
  setStepLogin: (type: AuthSectionSteps) => void;
}

export const StepNoLinkedCompanies = ({
  setStepLogin,
}: StepNoLinkedCompaniesProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="10px"
      padding="10px 60px"
      width="100%"
    >
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: '700',
          color: '#9E9E9E',
          textAlign: 'center',
        }}
      >
        Você não está cadastrado em nenhuma empresa, verifique seu cadastro
      </Typography>

      <Button
        variant="outlined"
        sx={{ height: '54px', marginTop: '30px' }}
        onClick={() => setStepLogin(AuthSectionSteps.LOGIN)}
      >
        Voltar ao Login
      </Button>
    </Box>
  );
};
